"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _data_1 = __importDefault(require("./_data"));

var generate_1 = __importDefault(require("./generate"));

var validate_1 = __importDefault(require("./validate"));

module.exports = {
  generate: generate_1["default"],
  validate: validate_1["default"],
  rawData: _data_1["default"],
  isValid: function isValid(name, opts) {
    console.log("namor: `isValid` has been renamed to `validate`");
    return validate_1["default"](name, opts);
  }
};